import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Button from "nx-components/Button";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import {
  IconRewind,
  IconPlay,
  IconPause,
  IconFastForward,
} from "nx-components/Icons";
import prefixStyles from "nx-components/utils/prefixStyles";
import Slider from "nx-components/Slider";

const styles = prefixStyles({
  detailsSpeakerControl: {
    padding: "5em",
    position: "relative",
    flex: "1 1 auto",
  },
});

export default class SpeakerDetailControls extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
  };

  onVolumeChanged(value) {
    if (value !== this.props.model.get("volume")) {
      this.props.model.setVolume(value);
    }
  }

  onPlay() {
    if (this.props.model.get("is_playing")) {
      this.props.model.pause();
    } else {
      this.props.model.play();
    }
  }

  onPrevious() {
    this.props.model.seekPrevious();
  }

  onNext() {
    this.props.model.seekNext();
  }

  render() {
    let PlayIcon = this.props.model.get("is_playing") ? IconPause : IconPlay;
    return (
      <div style={styles.detailsSpeakerControl}>
        <div>
          <Button
            disabled={!this.props.model.canSeekPrevious()}
            onTap={() => this.onPrevious()}
          >
            <IconRewind />
          </Button>
          <Button onTap={() => this.onPlay()}>
            <PlayIcon />
          </Button>
          <Button
            disabled={!this.props.model.canSeekNext()}
            onTap={() => this.onNext()}
          >
            <IconFastForward />
          </Button>
        </div>
        <Slider
          min="0"
          max="100"
          value={this.props.model.get("volume")}
          formatValue={(value) => `Volume ${value}%`}
          onChange={(value) => this.onVolumeChanged(value)}
          onDragStart={() => Dispatch("DISABLE_LOCATION_POLLING")}
          onDragEnd={() => Dispatch("ENABLE_LOCATION_POLLING")}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Speaker/SpeakerDetailControls.jsx